import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";

export const getListadoOrdenes = async (data) => {
  const respuesta = await PrivateInterceptor(
    "Compras/ListadoOrdenesCompra",
    "POST",
    data
  );
  return respuesta;
};

export const getListadoDetalleOrdenes = async (data) => {
  const respuesta = await PrivateInterceptor(
    "Compras/ListadoOrdenesCompra/Detalle",
    "POST",
    data
  );
  return respuesta;
};


// OBTIENE LAS ORDENES DE COMPRA 
export const obtenerOrdenCompra = async(PurchaseOrder) => {
  const result = await PrivateInterceptor('Compras/ListadoOrdenesCompra/obtenerOrdenCompra', 'POST', {PurchaseOrder})
  return result;
}

//Listado completo de las ordenes
export const obtenerDetalleOrdenCompra = async(PurchaseOrder) => {
  const result = await PrivateInterceptor('Compras/ListadoOrdenesCompra/obtenerDetalleOrdenCompra', 'POST', {PurchaseOrder})
  return result;
}

//Listado completo de las ordenes
export const obtenerDetalleOrdenSinCancelar = async(PurchaseOrder) => {
  const result = await PrivateInterceptor('Compras/ListadoOrdenesCompra/obtenerDetalleOrdenSinCancelar', 'POST', {PurchaseOrder})
  return result;
}

//Listado de las ordenes en estado OC
export const obtenerDetalleOrdenCompraOC = async(PurchaseOrder) => {
  const result = await PrivateInterceptor('Compras/ListadoOrdenesCompra/obtenerDetalleOrdenCompraOC', 'POST', {PurchaseOrder})
  return result;
}

// OBTIENER ULITMO ID DE ORDEN DE COMPRA
export const obtenerUltimoOrdenCompraId = async() => {
  const result = await PrivateInterceptor('Compras/ListadoOrdenesCompra/ObtenerUltimoIdOrderRequest', 'GET')
  return result;
}

export const sacarDetalleOC = async (IdPurchaseOrderDetail) => {
  const respuesta = await PrivateInterceptor('Compras/ListadoOrdenesCompra/sacarDetalleOC', 'POST',{ IdPurchaseOrderDetail });
  return respuesta;
}


//Obtener Siguiente Numero de Orden
export const obtenerNumeroOrden = async() => {
  const result = await PrivateInterceptor('Compras/ListadoOrdenesCompra/ObtenerNumeroOrden', 'GET')
  return result;
}


// GUARDAR ORDEN
export const GuardarOrden = async (data, data1) => {
  const respuesta = await PrivateInterceptor('Compras/ListadoOrdenesCompra/GuardarOrdenCompra', 'POST', {Encabezado: data, Detalle: data1});
  return respuesta;
}

// ELIMINAR ITEM ORDEN
export const cambiarEstadoOrdenDetalle = async (data) => {
  const respuesta = await PrivateInterceptor("Compras/ListadoOrdenesCompra/CambiarEstadoDetalle", "POST",{Detalle: data});
  return respuesta;
};

// EDITAR ORDEN
export const EditarOrden = async (data, data1) => {
  const respuesta = await PrivateInterceptor('Compras/ListadoOrdenesCompra/EditarOrdenCompra', 'POST', {Encabezado: data, Detalle: data1});
  return respuesta;
}

//Listado completo de las ordenes
export const PODProveedor = async(IdVendor) => {
  const result = await PrivateInterceptor('Compras/ListadoOrdenesCompra/PODProveedor', 'POST', {IdVendor})
  return result;
}

export const GetPODProveedor = async (IdVendor) => {
  // Construir la ruta con los parámetros proporcionados
  const route = `Compras/ListadoOrdenesCompra/GetPODProveedor/${IdVendor}`;
  
  // Llamar a la API utilizando el interceptor privado con el método GET
  const result = await PrivateInterceptor(route, 'GET');
  
  return result;
}

export const DatosCompletos = async (IdPurchaseOrder) => {
  const respuesta = await PrivateInterceptor('Compras/ListadoOrdenesCompra/DatosCompletos', 'POST',{ IdPurchaseOrder });
  return respuesta;
}

// export const getOrdenesEncabezado = async (MateriaPrima = false) => {
//   const result = await PrivateInterceptor(
//     `Compras/ListadoOrdenesCompra/getOrdenesEncabezado?MateriaPrima=${MateriaPrima ? 1 : 0}`,
//     'GET'
//   );
//   return result;
// }

export const getOrdenesEncabezado = async (MateriaPrima = false) => {
  const result = await PrivateInterceptor(
    'Compras/ListadoOrdenesCompra/getOrdenesEncabezado',
    'POST',
    {
      MateriaPrima: MateriaPrima ? 1 : 0,
    }
  );
  return result;
}

export const getOrdenesEncabezadoParaServicios = async() => {
  const result = await PrivateInterceptor('Compras/ListadoOrdenesCompra/getOrdenesEncabezadoParaServicios', 'GET')
  return result;
}

export const getOrdenesDetalles = async(IdPurchaseOrder) => {
  const result = await PrivateInterceptor('Compras/ListadoOrdenesCompra/getOrdenesDetalles', 'POST', {IdPurchaseOrder})
  return result;
}

export const getOrdenesDetallesCompletos = async(IdPurchaseOrder) => {
  const result = await PrivateInterceptor('Compras/ListadoOrdenesCompra/getOrdenesDetallesCompletos', 'POST', {IdPurchaseOrder})
  return result;
}

export const getBalanceOrdenDetalle = async (IdPurchaseOrderDetail) => {
  const result = await PrivateInterceptor(
    "Compras/ListadoOrdenesCompra/getBalanceOrdenDetalle",
    "POST",
    { IdPurchaseOrderDetail }
  );
  return result;
};